import TabMain from '../components/account/tabs/TabMain';
import TabChat from '../components/account/tabs/TabChat';
import TabProjects from '../components/account/tabs/TabProjects';
import TabTests from '../components/account/tabs/TabTests';
import TabTraining from '../components/account/tabs/TabTraining';
import TabEvents from '../components/account/tabs/TabEvents';
import TabMore from '../components/account/tabs/TabMore';
import TabProposal from '../components/account/tabs/TabProposal';
import TabSettings from '../components/account/tabs/tab-more/TabSettings';
import TabVacancy from '../components/account/tabs/tab-more/TabVacancy';
import TabTrack from '../components/account/tabs/TabTrack';
import TabCompetences from '@/components/account/tabs/TabCompetences';
import TabMentoring from '../components/account/tabs/TabMentoring';
import TabAchievements from '../components/account/tabs/tab-more/TabAchievements';
// import TabMentoring from '../components/account/tabs/TabMentoring';
import TabReporting from '../components/account/tabs/tab-more/TabReporting';
import { getStore } from '../store';
import TabInsternship from '@/components/account/tabs/tab-more/TabInsternship.vue';

export const section_basic = 0,
    section_extra = 1;

function defaultRedirect($router) {
    $router.push({ name: 'account-profile' });
}

const routes = [
    {
        name: 'account-profile',
        path: 'profile',
        component: TabMain,
        meta: {
            title: 'Профиль',
            section: section_basic,
            requiresAuth: true,
            canView: () => getStore().getters['isMobile'] || getStore().getters['isMobileApp'],
        },
    },

    {
        name: 'account-main',
        path: 'main',
        component: TabTrack,
        meta: { title: 'Основное', section: section_basic, icon: 'track', requiresAuth: true },
    },
    {
        name: 'account-competences',
        path: 'competences',
        component: TabCompetences,
        meta: { title: 'Компетенции', section: section_basic, icon: 'track', requiresAuth: true },
    },
    {
        name: 'account-projects',
        path: 'projects',
        component: TabProjects,
        meta: { title: 'Проекты', section: section_basic, requiresAuth: true },
    },
    {
        name: 'account-learn',
        path: 'learn',
        component: TabTraining,
        meta: { title: 'Обучение', section: section_basic, requiresAuth: true },
    },
    // {
    //     name: 'account-chat',
    //     path: 'chat',
    //     component: TabChat,
    //     meta: { title: 'Чаты', section: section_basic, requiresAuth: true },
    // },
    {
        name: 'account-insternship',
        path: 'internship',
        component: TabInsternship,
        meta: { title: 'Стажировки', section: section_basic, icon: 'reporting', requiresAuth: true },
    },
    // {
    //     name: 'account-testing',
    //     path: 'testing',
    //     component: TabTests,
    //     meta: { title: 'Тесты', section: section_basic, requiresAuth: true },
    // },
    {
        name: 'account-more',
        path: 'more',
        component: TabMore,
        meta: {
            title: 'Еще',
            section: section_basic,
            requiresAuth: true,
            canView: () => !(getStore().getters['isMobile'] || getStore().getters['isMobileApp']),
        },
    },
    // {
    //     name: 'account-events',
    //     path: 'events',
    //     component: TabEvents,
    //     meta: { title: 'Очные мероприятия', section: section_extra, icon: 'work', requiresAuth: true },
    // },
    {
        name: 'account-proposal',
        path: 'proposal',
        component: TabProposal,
        meta: { title: 'Заявки на проекты', section: section_extra, icon: 'claims', requiresAuth: true },
    },
    // {
    //     name: 'account-mentoring',
    //     path: 'mentoring',
    //     component: TabMentoring,
    //     meta: {
    //         title: 'Наставничество',
    //         section: section_extra,
    //         icon: 'user',
    //         requiresAuth: true,
    //         canView: () => getStore().getters['mentoring/isMentoringParticipant'],
    //         unauthorizedRedirect($router) {
    //             this.canView() || defaultRedirect($router);
    //         },
    //     },
    // },
    // {
    //     name: 'account-communities',
    //     path: 'communities',
    //     component: TabStub,
    //     meta: { title: 'Сообщества', section: section_extra, icon: 'groups', requiresAuth: true },
    // },
    // {
    //     name: 'account-job',
    //     path: 'job',
    //     component: TabStub,
    //     meta: { title: 'Работа', section: section_extra, icon: 'work', requiresAuth: true },
    // },
    // {
    //     name: 'account-settings',
    //     path: 'settings',
    //     component: TabSettings,
    //     meta: { title: 'Настройки', section: section_extra, icon: 'settings', requiresAuth: true },
    // },
    {
        name: 'account-achievements',
        path: 'achievements',
        component: TabAchievements,
        meta: { title: 'Достижения', section: section_extra, icon: 'achievements', requiresAuth: true },
    },
    {
        name: 'account-reporting',
        path: 'reporting',
        component: TabReporting,
        meta: { title: 'Персональные отчеты', section: section_extra, icon: 'reporting', requiresAuth: true },
    },
    {
        name: 'account-vacancy',
        path: 'vacancy',
        component: TabVacancy,
        meta: { title: 'Вакансии', section: section_extra, icon: 'vacancy', requiresAuth: true },
    },
    {
        path: '*',
        redirect: { name: 'account-main' },
    },
];

export default () => routes;
